module.exports = __webpack_public_path__ + "static/media/PROD_E2.f4a56e90.png";